import { render, staticRenderFns } from "./UnitQuestEdit.vue?vue&type=template&id=70d67d57&scoped=true&"
import script from "./UnitQuestEdit.vue?vue&type=script&lang=js&"
export * from "./UnitQuestEdit.vue?vue&type=script&lang=js&"
import style0 from "./UnitQuestEdit.vue?vue&type=style&index=0&id=70d67d57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d67d57",
  null
  
)

export default component.exports